import { environment } from '../../environments/environment';

function tryGetHostnameFromUrl(url: string | undefined | null): string | null {
  if (!url) return null;
  try {
    return new URL(url).hostname;
  } catch {
    return null;
  }
}

function tryGetHostnameFromQueryParam(paramName: string): string | null {
  try {
    const value = new URLSearchParams(window.location.search).get(paramName);
    return tryGetHostnameFromUrl(value);
  } catch {
    return null;
  }
}

function isAllowedHostname(hostname: string, allowedDomains: string[]): boolean {
  return allowedDomains.some((domain) => {
    if (!domain) return false;
    return hostname === domain || hostname.endsWith(`.${domain}`);
  });
}

export function shouldUseAuth0(): boolean {
  if (!environment.auth0?.allowedDomains?.length) {
    return false;
  }

  const allowedDomains = environment.auth0.allowedDomains;

  const parentUrlHostname =
    tryGetHostnameFromQueryParam('parentUrl');
  if (parentUrlHostname && isAllowedHostname(parentUrlHostname, allowedDomains)) {
    return true;
  }

  const referrerHostname = tryGetHostnameFromUrl(document.referrer);
  if (referrerHostname && isAllowedHostname(referrerHostname, allowedDomains)) {
    return true;
  }

  const ancestorOrigins: string[] =
    (window.location as any)?.ancestorOrigins?.length
      ? Array.from((window.location as any).ancestorOrigins as Iterable<string>)
      : [];
  for (const origin of ancestorOrigins) {
    const ancestorHostname = tryGetHostnameFromUrl(origin);
    if (ancestorHostname && isAllowedHostname(ancestorHostname, allowedDomains)) {
      return true;
    }
  }

  // Fallback to iframe/top-level hostname.
  const hostname = window.location.hostname;
  return isAllowedHostname(hostname, allowedDomains);
}

